import { actionIdSchema, outcomeIdSchema, screenIdSchema } from './ids';
import { domainEventNameSchema } from './events';

export const INITIAL_REVIEW_SCREEN_IDS = {
  intro: screenIdSchema.parse('initial-review-intro'),
  activity: screenIdSchema.parse('initial-review-activity'),
  checkIns: screenIdSchema.parse('initial-review-check-ins'),
} as const;

export const INITIAL_REVIEW_ACTION_IDS = {
  homeStart: actionIdSchema.parse('home.initial-review-start.activate'),
  homeContinue: actionIdSchema.parse('home.initial-review-continue.activate'),
  toolInvoke: actionIdSchema.parse('tool.open-weekly-plan-review.invoke'),
  introContinue: actionIdSchema.parse('initial-review.intro-continue.activate'),
  activityContinue: actionIdSchema.parse('initial-review.activity-continue.activate'),
  missingDay: actionIdSchema.parse('initial-review.missing-day.activate'),
  checkInsContinue: actionIdSchema.parse('initial-review.check-ins-continue.activate'),
  checkInsSkip: actionIdSchema.parse('initial-review.check-ins-skip.activate'),
  recapRetry: actionIdSchema.parse('initial-review.recap-retry.activate'),
  missingDayQuantityChange: actionIdSchema.parse('initial-review.missing-day-quantity.change'),
  missingDayDecrement: actionIdSchema.parse('initial-review.missing-day-decrement.activate'),
  missingDayIncrement: actionIdSchema.parse('initial-review.missing-day-increment.activate'),
  missingDaySave: actionIdSchema.parse('initial-review.missing-day-save.activate'),
  missingDayCancel: actionIdSchema.parse('initial-review.missing-day-cancel.activate'),
  completePlan: actionIdSchema.parse('initial-review.complete-plan.activate'),
  homeWeeklyReview: actionIdSchema.parse('home.weekly-review.activate'),
  completePlanReviewInvoke: actionIdSchema.parse('initial-review-v2.complete-plan-review.invoke'),
} as const;

export const INITIAL_REVIEW_OUTCOME_IDS = {
  toolSucceeded: outcomeIdSchema.parse('tool.open-weekly-plan-review.succeeded'),
  toolFailed: outcomeIdSchema.parse('tool.open-weekly-plan-review.failed'),
  sessionStarted: outcomeIdSchema.parse('initial-review.session.started'),
  completePlanReviewSucceeded: outcomeIdSchema.parse(
    'initial-review-v2.complete-plan-review.succeeded',
  ),
  completePlanReviewFailed: outcomeIdSchema.parse('initial-review-v2.complete-plan-review.failed'),
  sessionCompleted: outcomeIdSchema.parse('initial-review.session.completed'),
} as const;

export const INITIAL_REVIEW_DOMAIN_EVENT_NAMES = {
  planReviewCompleted: domainEventNameSchema.parse('member.plan.review.completed'),
} as const;
